import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRegistroRifiutiStep2Component } from './conservazione-carica-documento-registro-rifiuti-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-registro-rifiuti-step2', {
            url: '/conservazione-carica-documento-registro-rifiuti',
            ncyBreadcrumb: {
                label: 'Carica Registro Carico Scarico Rifiuti',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-registro-rifiuti-step2 flex="100"></conservazione-carica-documento-registro-rifiuti-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroRifiutiStep2Module: string = ng
    .module('conservazione-carica-documento-registro-rifiuti-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoRegistroRifiutiStep2', ConservazioneCaricaDocumentoRegistroRifiutiStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-rifiuti-step2/conservazione-carica-documento-registro-rifiuti-step2.module.ts